// Mappa sezione → video tutorial dedicato (registrazioni schermo reali, voce narrante).
// Video guida passo-passo: seguono le guide scritte, voce nativa per lingua (Isabella IT ecc.).
const H = (s) => ({ it: `/videos/help/${s}_it.mp4`, en: `/videos/help/${s}_en.mp4`, es: `/videos/help/${s}_es.mp4`, fr: `/videos/help/${s}_fr.mp4`, de: `/videos/help/${s}_de.mp4` });
const G = (k) => ({ it: `/videos/help/guide_${k}_it.mp4`, en: `/videos/help/guide_${k}_en.mp4`, es: `/videos/help/guide_${k}_es.mp4`, fr: `/videos/help/guide_${k}_fr.mp4`, de: `/videos/help/guide_${k}_de.mp4` });

export const SECTION_VIDEOS = {
  dashboard: G("dashboard"),
  cassa: G("cassa"),
  reservations: G("prenotazioni"),
  production: G("production"),
  partners: G("partners"),
  orders: G("orders"),
  recipes: G("recipes"),
  preparations: G("lab"),
  inventory: G("inventory"),
  inglist: H("inglist"),
  catalog: G("catalog"),
  reorder: G("reorder"),
  shifts: G("shifts"),
  azienda: G("azienda"),
  attendance: G("attendance"),
  invoices: G("invoices"),
  staff: G("staff"),
  waste: G("waste"),
  documents: G("documents"),
  payments: G("payments"),
  stats: G("stats"),
  reports: G("reports"),
  billing: G("billing"),
  formula: G("formula"),
  trash: G("trash"),
  permessi: H("permessi"),
};

export const ROUTE_SECTIONS = {
  "/app": "dashboard",
  "/app/cassa": "cassa",
  "/app/prenotazioni": "reservations",
  "/app/production": "production",
  "/app/partners": "partners",
  "/app/suppliers": "partners",
  "/app/orders": "orders",
  "/app/recipes": "recipes",
  "/app/formula": "formula",
  "/app/lab": "preparations",
  "/app/inventory": "inventory",
  "/app/ingredients-list": "inglist",
  "/app/catalog": "catalog",
  "/app/reorder": "reorder",
  "/app/shifts": "shifts",
  "/app/azienda": "azienda",
  "/app/attendance": "attendance",
  "/app/invoices": "invoices",
  "/app/staff": "staff",
  "/app/waste": "waste",
  "/app/documents": "documents",
  "/app/payments": "payments",
  "/app/stats": "stats",
  "/app/reports": "reports",
  "/app/billing": "billing",
  "/app/trash": "trash",
};

export const sectionForPath = (pathname) => ROUTE_SECTIONS[pathname.replace(/\/+$/, "")] || null;
